import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NotFoundPage = () => (
  <div className="max-w-3xl mx-auto px-4 md:px-6 py-16 text-center">
    <div className="mx-auto w-16 h-16 rounded-full bg-[var(--bb-sky-soft)] flex items-center justify-center">
      <Compass className="w-7 h-7 text-[var(--bb-pink-deep)]" />
    </div>
    <h1 className="font-display text-3xl font-bold mt-3">Lost in the chocolate jungle</h1>
    <p className="text-sm text-muted-foreground mt-1">We couldn’t find that page. Let’s get you back.</p>
    <Button asChild className="mt-5 h-12 rounded-xl bg-[var(--bb-pink)] hover:bg-[var(--bb-pink-deep)] text-white">
      <Link to="/">Back to home</Link>
    </Button>
  </div>
);

export default NotFoundPage;
